import { authFetch } from "./base";
export const fetchConfig = async () => {
    const response = await authFetch('api/config');
    return await response.json();
};
